import { render, staticRenderFns } from "./FeaturedCompanies.vue?vue&type=template&id=0ce86900&scoped=true&"
import script from "./FeaturedCompanies.vue?vue&type=script&lang=js&"
export * from "./FeaturedCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce86900",
  null
  
)

export default component.exports